var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("mode-checkbox", {
        staticClass: "option",
        attrs: {
          label: _vm.resource(
            "JourneyBuilder_Sankey_HighlightMode_MostSuccessful_Label"
          ),
          option: _vm.HIGHLIGHT_MODES.MOST_SUCCESSFUL_ROUTE
        },
        model: {
          value: _vm.valueModel,
          callback: function($$v) {
            _vm.valueModel = $$v
          },
          expression: "valueModel"
        }
      }),
      _vm._v(" "),
      _c("mode-checkbox", {
        staticClass: "option",
        attrs: {
          label: _vm.resource(
            "JourneyBuilder_Sankey_HighlightMode_LeastSuccessful_Label"
          ),
          option: _vm.HIGHLIGHT_MODES.LEAST_SUCCESSFUL_ROUTE
        },
        model: {
          value: _vm.valueModel,
          callback: function($$v) {
            _vm.valueModel = $$v
          },
          expression: "valueModel"
        }
      }),
      _vm._v(" "),
      _c("mode-checkbox", {
        staticClass: "option",
        attrs: {
          label: _vm.resource(
            "JourneyBuilder_Sankey_HighlightMode_MostTaken_Label"
          ),
          option: _vm.HIGHLIGHT_MODES.MOST_TAKEN_ROUTE
        },
        model: {
          value: _vm.valueModel,
          callback: function($$v) {
            _vm.valueModel = $$v
          },
          expression: "valueModel"
        }
      }),
      _vm._v(" "),
      _c("mode-checkbox", {
        staticClass: "option",
        attrs: {
          label: _vm.resource(
            "JourneyBuilder_Sankey_HighlightMode_LeastTaken_Label"
          ),
          option: _vm.HIGHLIGHT_MODES.LEAST_TAKEN_ROUTE
        },
        model: {
          value: _vm.valueModel,
          callback: function($$v) {
            _vm.valueModel = $$v
          },
          expression: "valueModel"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }